export default __webpack_public_path__ + "static/media/close.b0c70aa4.svg";